module.exports = __webpack_public_path__ + "static/media/datalovers.07dbd226.png";